module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dEbxwX/tc-custom/9783985311774.jpg?1703042201829",
      "alt": "This image is the cover for the book On Heroes, Hero-Worship, and the Heroic in History, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("On Heroes, Hero-Worship, and the Heroic in History, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("On Heroes, Hero-Worship, and The Heroic in History is a book by Thomas Carlyle, published by James Fraser, London, in 1841. It is a collection of six lectures given in May 1840 about prominent historical figures. It lays out Carlyle's belief in the importance of heroic leadership.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thomas Carlyle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Thomas Carlyle (4 December 1795 – 5 February 1881) was a Scottish historian, satirical writer, essayist, translator, philosopher, mathematician, and teacher. In his book On Heroes, Hero-Worship, and The Heroic in History (1841), he argued that the actions of the \"Great Man\" play a key role in history, claiming that \"the history of the world is but the biography of great men\". Other major works include The French Revolution: A History, 3 vols (1837) and The History of Friedrich II of Prussia, Called Frederick the Great, 6 vols (1858–65). His 1837 history of The French Revolution was the inspiration for Charles Dickens' 1859 novel A Tale of Two Cities, and remains popular today. Carlyle's 1836 Sartor Resartus is a notable philosophical novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0